/*
 |--------------------------------------------------------------------------
 | UI / mutations.js
 |--------------------------------------------------------------------------
 */

import Vue from 'vue'
import * as mutation from './mutation_types'

export default {
    [mutation.SET_BOAT_TYPE](state, type) {
        state.boatType = type
    },
    [mutation.SET_BOAT_MATERIAL](state, material) {
        state.boatMaterial = material
    },
    [mutation.SET_SAIL_FREQUENCY](state, frequency) {
        state.sailFrequency = frequency
    },
    [mutation.SET_COUNTRY](state, country) {
        state.country = country
    },
    [mutation.LOCAL_PRODUCTS](state, payload) {
        Vue.set(state.localProducts, payload.key, payload.products)
    }
}
